import HlsPlayer from './player/hlsPlayer'
import ShakaPlayer from './player/shakaPlayer'
import WebosPlayer from './player/webosPlayer'

import Ticker from './utils/ticker'
import { getMimetype } from './utils/media_tools'

export default class SpotvPlayer {
  constructor() {
    this.player_ = null
    this.mediaElement_ = null
    this.ticker_ = null

    /** @private */
    this.defaultConfig_ = {
      mediaElement: null,
      manifestUrl: null,
      os: "web", //web|lg|samsung,
      dvr: false,
      widevine: {
        lisenceUrl: null,
        token: null
      }
    }
  }

  /** @private */
  create_(os, mediaElement, manifestUrl) {
    this.mediaElement_ = mediaElement

    if (os.toLowerCase() == "lg") {
      this.player_ = new WebosPlayer(mediaElement, manifestUrl)    
    } else {
      const mimeType = getMimetype(manifestUrl)
      console.log("mimeType", mimeType)

      if (mimeType == 'application/vnd.apple.mpegurl') { 
        this.player_ = new ShakaPlayer(mediaElement, manifestUrl)
      } else if (mimeType == 'application/x-mpegURL') { // .m3u8
        this.player_ = new ShakaPlayer(mediaElement, manifestUrl)
      } else if (mimeType == 'application/dash+xml') { // .mpd
        this.player_ = new ShakaPlayer(mediaElement, manifestUrl)
      } else this.player_ = new HlsPlayer(mediaElement, manifestUrl)
    }
  }
  
  /**
   * craete target player and configure each options
   * @param {this.defaultConfig} config
   */
  configure(config) {
    const { os, mediaElement, manifestUrl, ...playerConfig_ } = Object.assign(this.defaultConfig_, config) 
    
    this.create_(os, mediaElement, manifestUrl)
    
    return this.player_.configure(playerConfig_)
  }
  
  /**
   * load media stream
   * @param {function()} callback 
   */
   async load(callback) {
     try {
       if (this.player_) {
         await this.player_.load().then(() => {
           console.log("The stream has now been loaded!")
           callback(true)
         }).catch((err) => { 
           this.player_.onError(err)
           callback(false)
         })
       }
       else {
         console.error("player is not defined")
         callback(false)
       }
     } catch (err) {
       callback(false)
     }
  }

   /**
   * update media timeline (interval per seconds)
   * schedule the ticker again first. onTick could cancel the timer and reshceduling
   * @param {Function()} onTick 
   * @param {Number} seconds - The Number of seconds for timer
   */ 
  tickInterval(onTick, timeToSeconds) {
    this.cancelTick()
    this.ticker_ = new Ticker(() => {
      // console.log("Ticker is ticking: ", timeToSeconds * 1000, "s")
      this.ticker_.tick(timeToSeconds)
      onTick()
    }).tick(timeToSeconds)
  }

  tickDebounce(onTick, timeToSeconds) {
    this.cancelTick()
    this.ticker_ = new Ticker(() => {
      onTick()
    }).tick(timeToSeconds)
  }

  /** @private */
  cancelTick() {
    if (this.ticker_) {
      this.ticker_.stop()
      this.ticker_ = null
    }
  }

  destroy() {
    // this.mediaElement.detach()
    // this.mediaElement.unload()
    this.cancelTick()
    if (this.player_) {
      this.player_.destroy()
      this.player_ = null
    }
  }
}